var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getSandboxUseCases } from 'app/constants/usecaseContants';
import queryString from 'query-string';
export var getAllowedUseCases = function (usecaseList) {
    var allowedUseCases = [];
    if (usecaseList) {
        usecaseList.forEach(function (usecaseItem) {
            getSandboxUseCases().forEach(function (item) {
                if (item.name === usecaseItem.name) {
                    allowedUseCases.push(__assign(__assign({}, usecaseItem), { logo: item.logo || null, priority: item.priority, graphLibrariesEnabled: item.graphLibrariesEnabled, persona: item.persona }));
                }
            });
        });
    }
    else {
        allowedUseCases = getSandboxUseCases();
    }
    return allowedUseCases.sort(function (a, b) { return a.priority - b.priority; });
};
export var findUsecaseByName = function (name, usecaseList) {
    var items = getAllowedUseCases(usecaseList);
    return items.find(function (uc) { return uc.name === name; });
};
export var isValidEmail = function (email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};
export var sleep = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
export var getURLDesiredSandbox = function (usecaseList) {
    if (window.location.search) {
        var hash = queryString.parse(window.location.search);
        if (hash.usecase) {
            var desiredUseCase = findUsecaseByName(hash.usecase, usecaseList);
            if (desiredUseCase) {
                return desiredUseCase;
            }
        }
    }
    return null;
};
